import { render } from "./StakingBody.vue?vue&type=template&id=549f2a94"
import script from "./StakingBody.vue?vue&type=script&lang=js"
export * from "./StakingBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__